<template>
  <div style="margin-top:10px;">
    <div class="row">
      <div class="col">
        <div class="shadow-box col-12">
          <div v-if="isEditMode">
            <table class="table table-bordered">
              <tbody>


              <tr>
                <th>Firma Adı</th>
                <td>{{ contractItems.companyName }}</td>
              </tr>
              <tr>
                <th>Firma Sicil Numarası</th>
                <td>{{ contractItems.companyRegistrationNumber}}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!-- Yeni kayıt modu için -->
          <div v-else>
            <!-- Mevcut firma arama kodu buraya -->
            <input
                type="text"
                v-model="query"
                @input="filterItems"
                @focus="showSuggestions = true"
                @blur="hideSuggestions"
                placeholder="Firma ara..."
                class="form-control"
            />
            <ul v-if="showSuggestions && filteredItems.length" class="suggestions">
              <li
                  v-for="item in filteredItems"
                  :key="item.id"
                  @mousedown="selectItem(item)"
                  class="suggestion-item"
              >
                {{ item.companyName }}
              </li>
            </ul>
            <a class="float-end" href="/companies" style="color: #0d6efd; margin-top:25px;">
              Firma Tanımla
            </a>
          </div>
        </div>
      </div>
    </div>


    <hr>

    <div class="row">
      <div  class="table-responsive" v-if="selectedItem">
        <h6>Firma Bilgileri</h6>
        <table class="table align-middle">
          <thead>
          <tr>
            <td><b>Firma Adı</b></td>
            <td><b>Firma Sicil No</b></td>
            <td><b>Firma Statü</b></td>
            <td><b>Çalışan Sayısı</b></td>
            <td><b>Segment</b></td>
            <td><b>Tehlike Sınıfı</b></td>
            <td><b>Firma Sınıfı</b></td>
            <td><b>Sektör</b></td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{selectedItem.companyName}}</td>
            <td>{{selectedItem.companyRegistrationNumber}}</td>
            <td >
              <div v-if="selectedItem.isSubcontractor">Alt Firma</div>
              <div v-if="!selectedItem.isSubcontractor">Üst Firma</div>
            </td>
            <td>{{selectedItem.companyDetails[0].companyEmployeesCount}}</td>
            <td>{{selectedItem.companyDetails[0].companySegment}}</td>
            <td>
              <div v-if="selectedItem.companyDetails[0].companyHazardLesson === 'LESS_DANGEROUS'"> Az Tehlikeli </div>
              <div v-if="selectedItem.companyDetails[0].companyHazardLesson === 'DANGEROUS'"> Tehlikeli </div>
              <div v-if="selectedItem.companyDetails[0].companyHazardLesson === 'MANY_DANGEROUS'"> Çok Tehlikeli </div>
            </td>
            <td>
              <div v-if="selectedItem.companyDetails[0].companyClass === 'ACTIVE'">Aktif</div>
              <div v-if="selectedItem.companyDetails[0].companyClass === 'PASSIVE'">Pasif</div>
              <div v-if="selectedItem.companyDetails[0].companyClass === 'POTENTIAL'">Potansiyel</div>
            </td>
            <td>
              {{selectedItem.companyDetails[0].companySector}}
            </td>

          </tr>
          </tbody>
        </table>
        <hr>
        <br>
      </div>


      <div class="col-12">


        <div class="mb-2">
          <label for="exampleFormControlInput1" class="form-label">Sözleşme No</label>
          <input type="text" class="form-control" v-model="contractItems.contractNumber" id="exampleFormControlInput1" placeholder="Sözleşme No">
        </div>



        <div class="mb-2">
          <label for="exampleFormControlInput1" class="form-label">Sözleşme Adı</label>
          <input type="text" class="form-control" v-model="contractItems.contractName" id="exampleFormControlInput1" placeholder="Sözleşme Adı">
        </div>


        <div class="mb-2">
          <label for="contractDate" class="form-label">Sözleşme Başlangıç Tarihi</label>
          <input type="date" class="form-control" v-model="contractItems.contractDate" id="contractDate" placeholder="Sözleşme Tarihi">
        </div>

        <div class="mb-2">
          <label for="contractTime" class="form-label">Sözleşme Süresi (Ay)</label>
          <input
              type="number"
              class="form-control"
              v-model.number="contractItems.contractTime"
              id="contractTime"
              min="1"
              placeholder="Sözleşme Süresi">
        </div>


        <div class="mb-2">
          <label for="renewalContractDate" class="form-label">Sözleşme Yenileme Tarihi</label>
          <input type="date" class="form-control" v-model="contractItems.renewalContractDate" id="renewalContractDate" placeholder="Sözleşme Yenileme Tarihi" readonly>
        </div>


        <div class="mb-2">
          <label for="exampleFormControlInput1" class="form-label">
            Damga Vergisi
          </label>
          <select class="form-select" v-model="contractItems.stampDuty">
            <option :value="0">Artı</option>
            <option :value="1">Müşteri</option>
            <option :value="2">Artı, Müşteri</option>
            <option :value="3">Gerekli Değil</option>
          </select>
        </div>

        <div class="mb-2">
          <label for="exampleFormControlInput1" class="form-label">Toplam Sözleşme Bedeli (Kdv hariç) - Otomatik Hesaplanır</label>
          <input type="number"
                 class="form-control"
                 id="exampleFormControlInput1"
                 placeholder="Personel fatura tutarlarından otomatik hesaplanır"
                 v-model.number="contractItems.contractPrice"
                 step="0.01"
                 readonly>
          <small class="form-text text-muted">Bu alan personel fatura tutarlarından otomatik olarak hesaplanır ve güncellenir.</small>
        </div>

        <div class="mb-2">
          <label for="exampleFormContFirmaInput2" class="form-label">OSGB Şube</label>
          <div class="mb-3">
            <select class="form-select" aria-label="OSGB Şube" v-model="contractItems.osgbBranchId">
              <option v-for="osgb in OsgbBranchData"
                      :key="osgb.id"
                      :value="osgb.id">
                {{ osgb.osgbBranchName }}
              </option>
            </select>

          </div>
        </div>


        <div class="mb-2">
          <label for="customerRepresentativeSelect" class="form-label">Müşteri Temsilcisi</label>
          <div class="mb-3">
            <select class="form-select" v-model.number="contractItems.customerRepresentativeUserId">
              <option v-for="user in usersData"
                      :key="user.id"
                      :value="user.id">
                {{ user.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-12">

        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Tanımlı Alanlar</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="mb-2" v-for="val in contractFields" v-bind:key="val.id">
                  <label for="exampleFormControlInput1" class="form-label">{{ val.name }}</label> &nbsp; &nbsp;
                  <input type="checkbox" @change="changeFields(val, $event)" :checked="val.isVisible" :name="val.id" :id="val.id"  placeholder="Alan adı"> -- {{val.inputType}}
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Kapat</button>
              </div>
            </div>
          </div>
        </div>


        <hr>

      </div>

    </div>

    <div class="row">
      <div v-for="(val, index) in selectedFields" :key="val">
        <div class="row">

          <div class="mb-2" v-if="val.inputType === 'CHECKBOX'">
            <div class="form-check">
              <input
                  class="form-check-input"
                  v-model="contractItems.contractFields[val.inputName]"
                  type="checkbox"
                  :id="`checkbox-${index}`"
              >
              <label class="form-check-label" :for="`checkbox-${index}`">
                {{ val.name }}
              </label>
            </div>
          </div>

          <div class="mb-2" v-else>
            <label :for="`input-${index}`" class="form-label">{{ val.name }}</label>
            <input
                :type="val.inputType"
                class="form-control"
                v-model="contractItems.contractFields[val.inputName]"
                :id="`input-${index}`"
                placeholder=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import apiClient from "@/axios";
import users from "../Users.vue";


export default {
  props: {
    contractItems: {
      type: Object,
      required: true,
      customerRepresentativeId: null
    },
    contractId: {
      type: [Number, String],
      default: null
    }
  },
  components:{},
  data(){
    return{
      customerRepId: null,
      inputItems:[],
      contractFields:[],
      OsgbBranchData: [],
      selectedFields:[],
      companiesData:[],
      showSuggestions: false,
      query: "",
      filteredItems: [],
      selectedItem: null,
      selectedCompany:{},
      items:[],
      stampDuty: 0,
      usersData: [],
      isLoading: false, // Yükleme durumu
      errorMessage: '',  // Hata mesajı
    }
  },
  watch: {
    'contractItems.osgbBranchId': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.contractItems.osgbBranch = { id: newVal };
        }
      }
    },
    'contractItems.osgbBranch': {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.contractItems.osgbBranchId = newVal.id;
        }
      }
    },
    customerRepId(newVal) {
      console.log('customerRepId changed:', newVal);
      this.contractItems.customerRepresentativeId = newVal;
    },
    'contractItems.customerRepresentativeId': {
      immediate: true,
      handler(newVal) {
        console.log('contractItems.customerRepresentativeId changed:', newVal);
        this.customerRepId = newVal;
      }
    },
    'contractItems': {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && newVal.companyname) {
          this.selectedItem = {
            companyName: newVal.companyname
          };
        }
      }
    },
    contractId: {
      handler(newVal) {
        if (newVal) {
          this.fetchContractData(newVal);
        }
      },
      immediate: true,
    },
    // ----> DEĞİŞİKLİK BURADA <----
    "contractItems.contractDate": "calculateRenewalDate",
    "contractItems.contractTime": "calculateRenewalDate",
  },
  computed: {
    users() {
      return users
    },
    isEditMode() {
      return !!this.contractItems?.id || !!this.contractId;
    }
  },
  mounted() {
    window.debugComponent = this; // geçici olarak
    console.log('Contract Data:', this.contractData);
    console.log('Users Data:', this.usersData);
    this.calculateRenewalDate(); // Bileşen yüklendiğinde de bir kez hesapla
  },
  created() {
    this.getData();
    this.getCompaniesData();
    this.getUserData();
    this.getOSGBBranchData();
    console.log('Contract Items:', this.contractItems);
  },
  methods:{
    // ----> BU METODLAR ARTIK GEREKLİ DEĞİL <----
    // handleContractTimeInput(event) { ... },
    // handleContractTimeChange(event) { ... },

    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('tr-TR');
    },
    formatCurrency(value) {
      if (!value) return '';
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
      }).format(value);
    },
    mapContractFromBackend(data) {
      return {
        id: data.id,
        contractNumber: data.contractnumber,
        contractName: data.contractname,
        companyName: data.companyname,
        contractDate: data.contractdate ? data.contractdate.split("T")[0] : null, // YYYY-MM-DD formatında al
        contractTime: data.contracttime,
        renewalContractDate: data.renewalcontractdate ? data.renewalcontractdate.split("T")[0] : null,
        stampDuty: data.stampduty,
        contractPrice: data.contractprice,
        osgbBranchId: data.osgbBranch?.id || data.osgbbranchid,
        customerRepresentativeUserId: parseInt(data.customerrepresentativeid) || null,
        contractFields: {}
      };
    },
    fetchContractData(id) {
      this.isLoading = true;
      this.errorMessage = '';
      apiClient.get(`/contract/${id}`)
          .then(res => {
            const data = res.data;
            this.contractItems = {
              ...this.mapContractFromBackend(data),
              osgbBranchId: data.osgbBranch?.id || data.osgbbranchid,
              osgbBranch: data.osgbBranch,
              companyname: data.companyname
            };
            this.contractId = id;
            this.selectedItem = {
              companyName: data.companyname
            };
            this.$nextTick(() => {
              this.calculateRenewalDate(); // Veri geldikten sonra tarihi hesapla
            });
          })
          .catch(error => {
            this.showError(this.parseError(error));
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    calculateRenewalDate() {
      // Değerlerin geçerli olduğundan emin ol
      if (this.contractItems.contractDate && this.contractItems.contractTime > 0) {
        let startDate = new Date(this.contractItems.contractDate);
        // Tarih objesinin geçerli olup olmadığını kontrol et
        if (isNaN(startDate.getTime())) return;

        startDate.setMonth(startDate.getMonth() + parseInt(this.contractItems.contractTime));
        this.contractItems.renewalContractDate = startDate.toISOString().split("T")[0]; // YYYY-MM-DD formatında
      }
    },
    filterItems() {
      const queryLower = this.query.toLowerCase();
      this.filteredItems = this.items.filter((item) =>
          item.companyName.toLowerCase().includes(queryLower)
      );
    },
    hideSuggestions() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
    },
    changeFields(field, event){
      if(event.target.checked === true){
        this.selectedFields.push(field)
      }else{
        let index = this.selectedFields.indexOf(field);
        if (index !== -1) {
          this.selectedFields.splice(index, 1);
        }
      }
    },
    selectItem(item) {
      this.query = item.companyName;
      this.selectedItem = item;
      this.showSuggestions = false;
      this.contractItems.company = {
        id: item.id
      };
      this.query = "";
    },
    getCompaniesData(){
      apiClient.get("companies/all").then(res => {
        this.companiesData = res.data;
        this.items = res.data;
      });
    },
    goCompanies(){
      this.$router.push({ name: 'companies' });
    },
    getData(){
      apiClient.get("contract-definition-fields").then(res =>  {
        let data = res.data;
        this.contractFields = res.data
        this.selectedFields = data.filter((item) => item.isVisible === true)

      })
    },
    getOSGBBranchData() {
      apiClient.get("osgbBranch").then(res => {
        this.OsgbBranchData = res.data;
        console.log("OSGB Branch Data:", res.data);

        if (this.contractItems.osgbBranchId) {
          const selectedBranch = this.OsgbBranchData.find(
              branch => branch.id === this.contractItems.osgbBranchId
          );
          if (selectedBranch) {
            this.contractItems.osgbBranchId = selectedBranch.id;
          }
        }
      });
    },
    getUserData(){
      apiClient.get("users").then(res =>  {
        this.usersData = res.data;
        console.log("Users Data:", res.data);
      })
    },

    // Hata mesajı gösterme metodu
    showError(message) {
      this.errorMessage = message;
      setTimeout(() => {
        this.clearError();
      }, 8000);
    },

    // Hata mesajını temizleme metodu
    clearError() {
      this.errorMessage = '';
    },

    // Backend hata mesajlarını detaylı olarak parse etme
    parseError(error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        // Sözleşme numarası duplicate hatası
        if (errorData.message && errorData.message.includes('contractnumber')) {
          return `Sözleşme numarası "${this.contractItems.contractNumber}" daha önce kullanılmış. Lütfen farklı bir sözleşme numarası giriniz.`;
        }

        // Duplicate key hatası
        if (errorData.message && errorData.message.includes('duplicate key')) {
          if (errorData.message.includes('contractnumber')) {
            return `Sözleşme numarası "${this.contractItems.contractNumber}" sistemde zaten mevcut. Lütfen farklı bir numara kullanınız.`;
          }
          return 'Bu sözleşme no daha önce girilmiş. Lütfen bilgileri kontrol ediniz.';
        }

        // Validation hataları
        if (errorData.errors && Array.isArray(errorData.errors)) {
          return errorData.errors.map(err => err.message || err).join(', ');
        }

        // Genel hata mesajı varsa
        if (errorData.message) {
          return errorData.message;
        }

        // Error string olarak gelmişse
        if (typeof errorData === 'string') {
          return errorData;
        }
      }

      // HTTP status kodlarına göre mesajlar
      if (error.response) {
        switch (error.response.status) {
          case 400:
            return 'Girilen bilgiler geçersiz. Lütfen tüm alanları kontrol ediniz.';
          case 409:
            return `Sözleşme numarası "${this.contractItems.contractNumber}" daha önce kullanılmış. Lütfen farklı bir numara giriniz.`;
          case 422:
            return 'Girilen veriler doğrulama kurallarına uymuyor. Lütfen bilgileri kontrol ediniz.';
          case 500:
            return 'Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyiniz.';
          default:
            return `Beklenmeyen bir hata oluştu (${error.response.status}). Lütfen sistem yöneticisi ile iletişime geçiniz.`;
        }
      }

      // Network hatası
      if (error.code === 'NETWORK_ERROR') {
        return 'Ağ bağlantısı hatası. Lütfen internet bağlantınızı kontrol ediniz.';
      }

      // Genel hata
      return 'Sözleşme kaydedilirken beklenmeyen bir hata oluştu. Lütfen tekrar deneyiniz.';
    },
  }

}
</script>


<style scoped>
.suggestions {
  position: absolute;
  width: calc(100% - 30px);
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ced4da;
  border-top: none;
  border-radius: 0 0 4px 4px;
  background-color: white;
  z-index: 1000;
}

.suggestion-item {
  padding: 8px 15px;
  cursor: pointer;
}

.suggestion-item:hover {
  background-color: #f8f9fa;
}

/* Disabled input için özel stil */
.form-control:disabled {
  background-color: #e9ecef !important;
  opacity: 1;
  cursor: not-allowed;
}

.selected-company {
  font-size: 16px;
  color: #495057;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 4px;
  min-height: 38px;
  display: flex;
  align-items: center;
}

.contract-details {
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.contract-details table {
  margin-bottom: 0;
}

.contract-details th {
  width: 200px;
  background-color: #f1f1f1;
}

.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

</style>
